import { useState, useEffect } from 'react';

export default function useIntersection(ref, threshold = 0.5, delay = 100, intersectOnlyOnce = false, reset = false) {
    const [isIntersected, setIsIntersected] = useState(false);

    useEffect(
      () => {
        if (ref.current) {
            if (typeof ob !== 'undefined' && reset) {
                ob.unobserve(ref.current);
            } else {
                const ob = new IntersectionObserver(
                    ([entry], observer) => {
                    if (entry.intersectionRatio >= threshold) {
                        setIsIntersected(true);
                        if (intersectOnlyOnce) {
                            ob.unobserve(ref.current);
                        }
                    } else {
                        setIsIntersected(false);
                    }
                    },
                    { threshold },
                    { delay },
                );
                ob.observe(ref.current);
                var mutationConfig = {
                    childList: true,
                    subtree: true,
                    characterData: true,
                };
                const mutationOb = new MutationObserver((mutations) => {
                    for (let mutation of mutations) {
                        if (mutation.type === 'characterData') {
                            let el = mutation.target;
                            let cls = 'villa-tile';
                            while ((el = el.parentNode) && el.className.indexOf(cls) < 0);
                            if ( el == ref.current ) {
                                ob.unobserve(ref.current);
                                ob.observe(ref.current);
                                setIsIntersected(false);
                                break;
                            }
                        }
                      }
                });
                mutationOb.observe(ref.current, mutationConfig);

                return () => {
                    ob.unobserve(ref.current);
                    mutationOb.disconnect(ref.current);
                };
            }
        }
      },
      [ref.current, threshold, reset]
    );
    return isIntersected;
  }